export const DRAG_PREVIEW_WIDTH = 240;
export const DRAG_PREVIEW_HEIGHT = 180;

export const BOARD_DRAG_PREVIEW_WIDTH = 180;
export const BOARD_DRAG_PREVIEW_HEIGHT = 160;

// Pixels to offset the drag ghost so the cursor tip appears near the top-left corner of the preview
export const DRAG_GHOST_CURSOR_OFFSET = 16;
